module.exports = __webpack_public_path__ + "media/images/ic_callus-e4df2d9cc0e35e2b869537eb2d58d123.svg";